export default function ResponsibilityOfTheVisitor() {
  return <section id="3-ευθύνη-του-επισκέπτη" className="bg-background py-24">
      <div className="mx-auto max-w-[60rem] px-4 md:px-6">
        <div className="mb-6 h-1 w-16 bg-accent" aria-hidden="true" />
        <h2 className="mb-8 font-default text-[clamp(2rem,5vw,3.5rem)] font-bold text-primary">
          3. Ευθύνη του Επισκέπτη
        </h2>
        <p className="font-sans text-xl leading-relaxed text-primary">
          Αποτελεί αποκλειστική ευθύνη του χρήστη να διαβάσει προσεκτικά και να κατανοήσει την πολιτική ακύρωσης του επιλεγμένου δωματίου πριν προχωρήσει στην οριστική ολοκλήρωση της κράτησής του. Οι όροι αυτοί αναγράφονται με σαφήνεια στο βήμα της κράτησης, καθώς και στο επίσημο email επιβεβαίωσης (voucher) που λαμβάνετε.
        </p>
      </div>
    </section>;
}